import React from "react";
import { DropdownSectionBusinessTypes } from "./sections";

export default function DropdownBusinessTypes() {
  return (
    <>
      <DropdownSectionBusinessTypes />
    </>
  );
}
